export default function DatapointdisplayObjects(gettextCatalog) {
	'ngInject';

	var service = {
		getChartTypes: _getChartTypes,
		getAggregateFunctions: _getAggregateFunctions
	};

	function _getChartTypes() {
		var chartTypeOptions = [
			{
				label: '---',
				value: null,
				description: ''
			},
			{
				label: gettextCatalog.getString('Line Chart'),
				value: 'line',
				description: gettextCatalog.getString('Standard line chart with multiple aggregates on single chart.')
			},
			{
				label: gettextCatalog.getString('Step Chart'),
				value: 'step',
				description: gettextCatalog.getString('Step chart for state values.')
			},
			{
				label: gettextCatalog.getString('Step Chart - Disconnected'),
				value: 'step_disconnected',
				description: gettextCatalog.getString(
					'Step chart for state values where connection is not appropriate. (E.g. more than 3 states)'
				)
			}
		];

		return chartTypeOptions;
	}

	function _getAggregateFunctions() {
		var aggregateFunctions = [
			{
				label: gettextCatalog.getString('Mean'),
				value: 'mean'
			},
			{
				label: gettextCatalog.getString('Min'),
				value: 'min'
			},
			{
				label: gettextCatalog.getString('Max'),
				value: 'max'
			},
			{
				label: gettextCatalog.getString('First'),
				value: 'first'
			},
			{
				label: gettextCatalog.getString('Last'),
				value: 'last'
			},
			{
				label: gettextCatalog.getString('Count'),
				value: 'count'
			},
			{
				label: gettextCatalog.getString('Delta'),
				value: 'delta'
			}
		];

		return aggregateFunctions;
	}

	return service;
}
